//Авторизация, выбор языка и темы интерфейса, настройки аккаунта, общее поведение интерфейса
import {backendPostRequest} from "@/domain/backend.api";
import Router from "@/router";
import i18n from "@/i18n";
import router from "@/router";

export default {
    namespaced: true,
    state: {
        backendApiUrl: process.env.VUE_APP_BackendApiUrl, //"http://localhost:3000/", //api внутреннего бэкенда авторизации
        proxy: process.env.VUE_APP_Proxy, //для обхода cors во время отладки

        user: {
            email: "",
            // accessToken: "",
            // refreshToken: "",
        },

        userProps:{},

        isLoading: false,

        messageDialog: {
            trigger: false,
            title: "Заголовок",
            description: "Описание",
            buttonTitle: "Закрыть",
        },

        toastMessage: null,
    },

    mutations: {
        setUserProps(state, payload){
            state.userProps = payload
            localStorage.setItem('userProps', JSON.stringify(payload))
        },

        setIsLoading(state, status) {
            state.isLoading = status
        },

        setUser(state, user) {
            state.user = user
            //console.log(state.user)
            localStorage.setItem('email',user.email)
            // localStorage.setItem('accessToken',user.accessToken)
            // localStorage.setItem('refreshToken',user.refreshToken)
        },

        clearUser(state){
            state.user = {
                email: "",
                // accessToken: "",
                // refreshToken: "",
            }
            localStorage.removeItem('email')
            // localStorage.removeItem('accessToken')
            // localStorage.removeItem('refreshToken')
        },

        setMessageDialog(state, payload) {
            state.messageDialog = payload
        },

        setToastMessage(state, payload) {
            state.toastMessage = payload.message
        },

    },

    actions: {
        async apiBackendLogin({ commit, dispatch }, payload) {
            //console.log(dispatch, commit, payload)
            commit("setIsLoading", true)

            const result = await backendPostRequest("auth/login", {
                email: payload.login,
                password: payload.password,
            })

            if (result.status==="ok"){
                commit("setUser", {
                    email: payload.login,
                    accessToken: result.accessToken,
                    refreshToken: result.refreshToken,
                })

                dispatch("apiBackendGetProps")

                commit("setIsLoading", false)
                await Router.push({name: 'MainPage'})
                commit("setToastMessage", { message: i18n.t("common.login_success") })
            }
            else if (result.status==="fail" && result.message==="User not activated"){
                commit("setIsLoading", false,)
                commit("setMessageDialog", {
                    trigger: true,
                    title: i18n.t("common.title_warning"),
                    description: i18n.t("common.register_not_activated"),
                    buttonTitle: i18n.t("common.button_close"),
                })
            }
            else {
                commit("setIsLoading", false)
                commit("setMessageDialog", {
                    trigger: true,
                    title: i18n.t("common.title_error"),
                    description: i18n.t("common.login_error"),
                    buttonTitle: i18n.t("common.button_close"),
                })

            }
        },

        async apiBackendRegister({ commit }, payload) {
            commit("setIsLoading", true)
            const result = await backendPostRequest("auth/registration", {
                email: payload.login,
                password: payload.password,
            })

            if (result.status === "ok") {
                // commit("setUser", {
                // 	email: payload.login,
                // 	accessToken: result.accessToken,
                // 	refreshToken: result.refreshToken,
                // })

                commit("setIsLoading", false)
                await router.push({name: "LoginPage"})
                commit("setMessageDialog", {
                    trigger: true,
                    title: i18n.t("common.title_info"),
                    description: i18n.t("common.register_success"),
                    buttonTitle: i18n.t("common.button_close"),
                })
            } else {
                console.log("error:", result)
                commit("setIsLoading", false)
                commit("setMessageDialog", {
                    trigger: true,
                    title: i18n.t("common.title_error"),
                    description: JSON.stringify(result),
                    buttonTitle: i18n.t("common.button_close"),
                })
            }
        },

        async apiBackendRestore({ commit }, payload) {
            //console.log(dispatch, payload)
            commit("setIsLoading", true)
            const result = await backendPostRequest("auth/restore", {
                email: payload.email,
            })
            //console.log(result)

            if (result.status === "ok") {
                commit("setIsLoading", false)
                //
                commit("setMessageDialog", {
                    trigger: true,
                    title: i18n.t("common.title_info"),
                    description: i18n.t("common.restore_succes"),
                    buttonTitle: i18n.t("common.button_close"),
                })
            } else {
                commit("setMessageDialog", {
                    trigger: true,
                    title: i18n.t("common.title_error"),
                    description: JSON.stringify(result),
                    buttonTitle: i18n.t("common.button_close"),
                })

                commit("setIsLoading", false)
            }
        },

        async apiBackendRestoreChange({ commit }, payload) {
            commit("setIsLoading", true)
            try {
                const result = await backendPostRequest("auth/restorechange", payload)
                if (result.status === "ok") {
                    commit("setMessageDialog", {
                        trigger: true,
                        title: i18n.t("common.title_info"),
                        description: i18n.t("common.restore_success"),
                        buttonTitle: i18n.t("common.button_close"),
                    })
                } else {
                    commit("setMessageDialog", {
                        trigger: true,
                        title: i18n.t("common.title_error"),
                        description: JSON.stringify(result),
                        buttonTitle: i18n.t("common.button_close"),
                    })
                }
            } catch (e) {
                commit("setMessageDialog", {
                    trigger: true,
                    title: i18n.t("common.title_error"),
                    description: i18n.t("common.restore_error"),
                    buttonTitle: i18n.t("common.button_close"),
                })
            }
            commit("setIsLoading", false)
        },

        async apiBackendChangePassword({ commit }, payload){
            console.log(commit, payload)
            const result = await backendPostRequest("auth/changepassword", payload)
            //console.log(result)
            if (result.status==="ok"){
                commit("setMessageDialog", {
                    trigger: true,
                    title: i18n.t("common.title_info"),
                    description: i18n.t("common.change_password_success"),
                    buttonTitle: i18n.t("common.button_close"),
                })
            }else {
                commit("setMessageDialog", {
                    trigger: true,
                    title: i18n.t("common.title_error"),
                    description: i18n.t("common.change_password_error"),
                    buttonTitle: i18n.t("common.button_close"),
                })

            }

        },

        async apiBackendLogout({ commit }){

            // const result = await backendPostRequest("auth/logout", {})
            //
            // if (result.status === "ok") {
                commit("setUser", {
                    email: "",
                    accessToken: "",
                    refreshToken: "",
                })

                commit("clearUser")

            window.keycloak.logout(window.keycloakOptions)
            //
            //     commit("setIsLoading", false)
            //     commit("setToastMessage", { message: i18n.t("common.logout_success") })
            //     await Router.push({name: 'LoginPage'})
            // } else {
            //     console.log("error:", result)
            //     commit("setIsLoading", false)
            //     commit("clearUser")
            //     commit("setMessageDialog", {
            //         trigger: true,
            //         title: i18n.t("common.title_error"),
            //         description: JSON.stringify(result),
            //         buttonTitle: i18n.t("common.button_close"),
            //     })
            //     await Router.push({name: 'LoginPage'})
            // }
        },

        async apiBackendGetProps({commit}){
            //console.log(commit)
            let props = localStorage.getItem('userProps')
            if (props===null || props === undefined){
                props = JSON.stringify({language:'ru', theme:'light'})
                console.log('set user props',props)
                localStorage.setItem('userProps', props)
            }
            console.log('props',props)
            commit("setUserProps", JSON.parse(props))
            // const result = await backendPostRequest("users/getprops", {})
            //
            // console.log('response apiBackendGetProps',result)
            // if (result.status==="ok"){
            //     commit("setUserProps", result.props)
            // }

        },

        async apiBackendSetProps({commit}, payload){
            //console.log(commit)
            localStorage.setItem('userProps', JSON.stringify(payload))
            commit("setUserProps", payload)
            // const result = await backendPostRequest("users/setprops", payload)
            // if (result.status==="ok"){
            //     commit("setUserProps", result.props)
            // }
            //console.log('response apiBackendSetProps',result)
        },

        async apiBackendSetProperty({commit, state}, {property, value}){
            //console.log(commit,payload)
            // console.log('property', property)
            // console.log('value', value)
            // console.log(commit)
            // console.log('>>props',state.userProps)
            let data = JSON.parse(JSON.stringify(state.userProps))
            // console.log('data',data)
            data[property]=value
            commit("setUserProps", data)
            // const result = await backendPostRequest("users/setproperty", payload)
            // if (result.status==="ok"){
            //     commit("setUserProps", result.props)
            // }
            //console.log('response apiBackendSetProps',result)
        },

        async apiBackendEcho({commit}, payload){
            console.log(commit)
            const result = await backendPostRequest("users/echo", payload)
            console.log('<echo>')
            console.log(result)
            console.log('</echo>')

        },

        //======================

        // loadUserFromLocalStorage({commit}){
        //     //console.log('loadUserFromLocalStorage')
        //     const accessToken = localStorage.getItem('accessToken')
        //     if (accessToken!==null){
        //         //console.log('accessToken', accessToken)
        //         commit("setUser", {
        //             email: localStorage.getItem('email'),
        //             accessToken: accessToken,
        //             refreshToken: localStorage.getItem('refreshToken'),
        //         })
        //     }
        // },

        closeMessageDialog({ commit }) {
            let payload = {
                trigger: false,
                title: "",
                description: "",
                buttonTitle: "",
            }
            commit("setMessageDialog", payload)
        },

        copyToClipBoard({ commit }, CopyText) {
            console.log(commit)
            console.log(CopyText)
            if (navigator.clipboard) {
                const inputValue = CopyText
                navigator.clipboard
                    .writeText(inputValue)
                    .then(() => {
                        console.log("Скопировали")
                        commit("setToastMessage", { message: i18n.t("common.clipboard_success") })
                    })
                    .catch((err) => {
                        console.log("Ошибка", err)
                        commit("setToastMessage", { message: i18n.t("common.clipboard_error") })
                    })
            } else {
                //console.log('Нет поддержки')
            }
        },

    },

    getters: {
        getUserProps(state){
            return state.userProps
        },

        getIsLoading(state) {
            return state.isLoading
        },
        getBackendApiUrl(state) {
            return state.backendApiUrl
        },

        getProxy(state) {
            return state.proxy
        },
        getUser(state) {
            return state.user
        },
        getMessageDialog(state) {
            return state.messageDialog
        },
        getToastMessage(state) {
            return state.toastMessage
        },

    }
}